import React, { createContext, useContext, useEffect, useState } from "react";

const WlCtx = createContext(null);

export function WishlistProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem("acchajee_wl") || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem("acchajee_wl", JSON.stringify(ids)); }, [ids]);
  const toggle = (id) => setIds((prev) => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  const has = (id) => ids.includes(id);
  return <WlCtx.Provider value={{ ids, toggle, has }}>{children}</WlCtx.Provider>;
}

export const useWishlist = () => useContext(WlCtx);
